import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import {PrimaryColor, SecondaryColor, UnimportantColor} from "@/modules/constants";

Vue.use(Vuetify, {
  theme: {
    primary: PrimaryColor,
    secondary: SecondaryColor,
    unimportantColor: UnimportantColor,
  },
  customProperties: true,
  iconfont: 'md',
});
